/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

// import './LanguageDropdownList.css';

import SelectInput from '../../common/SelectInput/SelectInput';
import withListLocale from './withListLocale';

const SelectInputWithLocale = withListLocale(SelectInput);

const LanguageDropdownList = (props) => (
  <SelectInputWithLocale {...props} />
);

export default LanguageDropdownList;
